module.exports = __webpack_public_path__ + "img/parter-avatar12.582e72c3.png";